import React, { useMemo, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { getThemeByName } from "./Theme";

const CustomThemeContext = React.createContext({
  currentTheme: "indigoTheme",
  setTheme: () => { },
});

const CustomThemeProvider = ({ children }) => {
  const getInitialThemeName = () => {
    if (typeof window === "undefined") {
      return "indigoTheme";
    }

    const savedTheme = window.localStorage.getItem("appTheme");
    return savedTheme && getThemeByName(savedTheme) ? savedTheme : "indigoTheme";
  };

  const [themeName, setThemeNameState] = useState(getInitialThemeName);

  const setThemeName = (name) => {
    const nextThemeName = getThemeByName(name) ? name : "indigoTheme";

    if (typeof window !== "undefined") {
      window.localStorage.setItem("appTheme", nextThemeName);
    }

    setThemeNameState(nextThemeName);
  };

  const theme = useMemo(
    () => getThemeByName(themeName) || getThemeByName("indigoTheme"),
    [themeName]
  );

  const contextValue = useMemo(
    () => ({
      currentTheme: themeName,
      setTheme: setThemeName,
    }),
    [themeName]
  );

  return (
    <CustomThemeContext.Provider value={contextValue}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </CustomThemeContext.Provider>
  );
};

export { CustomThemeContext, CustomThemeProvider };
